import type { Profile } from "Types/Profile";

export type GetProfilesQueryReturn = {
    getPhonesEmails: {
        items: Profile[];
        total: number;
    };
};

// ENUM CLEAN UP
// eslint-disable-next-line no-restricted-syntax
export enum DialPadViews {
    CONTACT_SEARCH = "contactSearch",
    FROM_NUMBER_PICKER = "fromNumberPicker",
}

// ENUM CLEAN UP
// eslint-disable-next-line no-restricted-syntax
export enum DialPadActions {
    CALL = "call",
    SMS = "sms",
    EMAIL = "email",
}
